var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableDottesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.95635 2.23076C4.57013 0.616988 6.98497 0 10.0977 0H17.3535C20.4662 0 22.881 0.616988 24.4948 2.23076C26.1086 3.84454 26.7256 6.25938 26.7256 9.37209V16.6279C26.7256 19.7406 26.1086 22.1555 24.4948 23.7692C22.881 25.383 20.4662 26 17.3535 26H10.0977C6.98497 26 4.57013 25.383 2.95635 23.7692C1.34257 22.1555 0.725586 19.7406 0.725586 16.6279V9.37209C0.725586 6.25938 1.34257 3.84454 2.95635 2.23076ZM4.23901 3.51342C3.13185 4.62058 2.53954 6.43829 2.53954 9.37209V16.6279C2.53954 19.5617 3.13185 21.3794 4.23901 22.4866C5.34616 23.5937 7.16388 24.186 10.0977 24.186H17.3535C20.2873 24.186 22.105 23.5937 23.2122 22.4866C24.3193 21.3794 24.9116 19.5617 24.9116 16.6279V9.37209C24.9116 6.43829 24.3193 4.62058 23.2122 3.51342C22.105 2.40627 20.2873 1.81395 17.3535 1.81395H10.0977C7.16388 1.81395 5.34616 2.40627 4.23901 3.51342Z",
    fill: "#1B224C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3496 13.0003C17.3496 12.3324 17.891 11.791 18.5589 11.791H18.5697C19.2376 11.791 19.779 12.3324 19.779 13.0003C19.779 13.6682 19.2376 14.2096 18.5697 14.2096H18.5589C17.891 14.2096 17.3496 13.6682 17.3496 13.0003Z",
    fill: "#1B224C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5107 13.0003C12.5107 12.3324 13.0522 11.791 13.72 11.791H13.7309C14.3988 11.791 14.9402 12.3324 14.9402 13.0003C14.9402 13.6682 14.3988 14.2096 13.7309 14.2096H13.72C13.0522 14.2096 12.5107 13.6682 12.5107 13.0003Z",
    fill: "#1B224C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67236 13.0003C7.67236 12.3324 8.21379 11.791 8.88167 11.791H8.89253C9.5604 11.791 10.1018 12.3324 10.1018 13.0003C10.1018 13.6682 9.5604 14.2096 8.89253 14.2096H8.88167C8.21379 14.2096 7.67236 13.6682 7.67236 13.0003Z",
    fill: "#1B224C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDottesIcon);
export default __webpack_public_path__ + "static/media/tableDottesIcon.9190d02d376a0669e8293ddbd5243745.svg";
export { ForwardRef as ReactComponent };